import { QUERY_KEYS } from 'api/query-keys';
import { partnerService } from 'hq/services';
import { useQuery } from 'react-query';
import { CACHE_TIME_LONG, STALE_TIME_LONG } from 'shared/react-query/query-defaults';

const useGetPartnerRelations = (id: string) => {
  const queryFn = async () => await partnerService.getPartnerRelations(id);

  return useQuery(QUERY_KEYS.partnerRelations(id), {
    queryFn,
    cacheTime: CACHE_TIME_LONG,
    staleTime: STALE_TIME_LONG,
  });
};

export { useGetPartnerRelations };
